import { connect } from 'react-redux'
import component from './component'
import { fetchSaveShoppingList } from './actions/data'


const mapStateToProps = state => ({
    ...state.formItems,
    theme: state.configuration.modifiers.theme
})

export default connect(
    mapStateToProps,
    { fetchSaveShoppingList }
)(component)
